import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useMutation } from "@grandvisionhq/graphql";
import { useDispatchTrackErrorEvent } from "@grandvisionhq/svc-tealium/events";
import { useMutationConfig } from "../../../../../../../../../../hooks/operations/hooks/operations/use-mutation-config.js";
import { CREATE_APPLE_PAY_SESSION } from "../../../../../../../../../../operations/mutations/operations/mutations/create-apple-pay-session.js";
import { CheckoutErrorsMapping } from "../../../../../../../../../../mappers/mappers/errors-mapping.js";
const useCreateApplePaySession = ({
  onError,
  onCompleted
} = {}) => {
  const [session, setSession] = React.useState(null);
  const { mutationOptions } = useMutationConfig({ onError, onCompleted });
  const dispatchTrackErrorEvent = useDispatchTrackErrorEvent();
  const [mutationCallback, mutation] = useMutation(
    CREATE_APPLE_PAY_SESSION,
    mutationOptions
  );
  React.useEffect(() => {
    const merchantSessionData = mutation?.data?.createApplePaySession?.data;
    if (session && merchantSessionData) {
      const decodedMerchantSession = atob(merchantSessionData);
      const decodedAndParsedMerchantSession = JSON.parse(decodedMerchantSession);
      try {
        session.completeMerchantValidation(decodedAndParsedMerchantSession);
      } catch (e) {
        if (!(e instanceof Error && e.name === "InvalidAccessError")) {
          console.error(e);
          toast.failed(CheckoutErrorsMapping.SomethingWentWrong);
          dispatchTrackErrorEvent(
            () => Promise.resolve({
              Error_Source: "Server",
              Error_Code: "Create apple pay session error",
              Error_Details: CheckoutErrorsMapping.SomethingWentWrong,
              Error_Message: e instanceof Error ? e.message : ""
            })
          );
          throw e;
        }
      }
    }
  }, [
    session,
    mutation?.data?.createApplePaySession?.data,
    mutation?.data?.createApplePaySession,
    mutation?.data
  ]);
  const domainName = typeof window !== "undefined" && window?.location?.hostname;
  const createApplePaySession = React.useCallback(
    async (session2) => {
      setSession(session2);
      await mutationCallback({
        variables: {
          applePaySessionInput: {
            domainName
          }
        }
      });
    },
    [domainName, mutationCallback]
  );
  return { createApplePaySession, isLoading: mutation.loading, updateError: mutation.error };
};
export {
  useCreateApplePaySession
};
//# sourceMappingURL=use-create-apple-pay-session.js.map
